import { render, staticRenderFns } from "./MultistepTemplate.vue?vue&type=template&id=531f1fbb"
import script from "./MultistepTemplate.vue?vue&type=script&lang=js"
export * from "./MultistepTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports